module.exports = __webpack_public_path__ + "d3339ea6c3321c4aeca2fc244abc3042.png";